if(typeof(ConstructorioHelperJS) == "undefined" || ConstructorioHelperJS == null || !ConstructorioHelperJS){
	var ConstructorioHelperJS = (function(){
		var LOCALSTORAGE_CONSTRUCTORIO_API_KEY = "constructorio_api_accesstoken",
		widgetsFiredForRecommetnaions=[],
		productIdToFetchPrice=[],
		solrProductPriceMap={},
		cookieKeyRfkAccessToken= "RFK_ACCESS_TOKEN",			
		REFLEKTION_ACCESS_TOKEN="",
		IS_KEY_RETRIVED=false,
		REFLEKTION_API_URL_HOST="",
		REFLEKTION_GET_ACCESS_TOKEN_URL="",
		REFLEKTION_API_HOST="",
		REFLEKTION_API_TIMEOUT="",
		REFLEKTION_SKU_PARTNUM_FIELD = "sku_partnumber",
		DEFINING_ATTRIBUTE_PREFIX = 'ptc_omni',
		reflectionAutoCompleteRequests={},		
		DEFINING_ATTRIBUTE_LIST=["ptc_omni_item_weight","ptc_omni_pkg_quantity","ptc_omni_size","ptc_omni_wattage_max","ptc_omni_item_height","ptc_omni_item_length","ptc_omni_item_width","ptc_omni_vol","ptc_omni_finish","ptc_omni_full_dims","ptc_omni_gallons_hr","ptc_omni_amount","ptc_omni_length","ptc_omni_pet_weight_min","ptc_omni_item_circumference","ptc_omni_item_depth","ptc_omni_petsize"],		
		rfkRecommendationRequest = {},
		recommendationParsedSkuDetails = {},
		recommendationWidgetProcessed = "",
		USER_CONTEXT = {},
		RECOMMENDATION_PDP_SKU="",
		AUTOCOMPLETE_PREVIOUS_SEARCH_TERM=" ",
		IS_AUTOCOMPLETE_DATA_FETCHED=false,
		RFKIDMAP={},
		ENABLE_CONSTRUCTORIO=false,
		ENABLE_CONSTRUCTOR=false,
		retrievedCachedSuggestions=false,
		CachedSuggestionsURL="",
		recommendationCustomWidgetArr = [],
		isCallInitialtedForSOlr=false;
		SEARCH_SOURCE_KEY = "search_source";

				function accessCIOAccessToken(){
			var accessTokenJSON = $("#CONSTRUCTOR_KEY").val();
		}

				function getConstructorioEnabled(){
			var isConstructorEnabled = $("#ENABLE_CONSTRUCTORIO_RECOMMENDATION");
			if(isConstructorEnabled.length > 0 && isConstructorEnabled.val() == 'true'){
				ENABLE_CONSTRUCTORIO = true;
			}
			var isConstructorEnabled = $("#isConstructorSearchEnabled");
			if(isConstructorEnabled.length > 0 && isConstructorEnabled.val() == 'true'){
				ENABLE_CONSTRUCTOR = true;
			}
		}
		function showAutoSuggest_RFL(decission){
			if(decission){
				$("#look-ahead").addClass("active");
			}else{
				$("#look-ahead").removeClass("active");
			}
		}

				function autoComplete_init(){
			getConstructorioEnabled();
			if(typeof(document.CatalogSearchForm) != "undefined" 
				&& typeof(document.CatalogSearchForm.searchTerm) != "undefined" && ENABLE_CONSTRUCTOR){
				$(document.CatalogSearchForm.searchTerm).on("click keyup blur", function(event) {
					var autoSuggestCall = setInterval(function(){ 

												clearInterval(autoSuggestCall);
						if(event.type == "blur"){
							setTimeout(function(){showAutoSuggest_RFL(false)},800)
						}else if(event.type == "keyup" && event.keyCode == 13){
							if (ConstructorioHelperJS.checkBeforeSearchSubmit()) {
								document.CatalogSearchForm.submit();
							}
							return;
						}else{
							reflextion_populateAutoComplete();
						}


																		}, 100);

									});

							}
		}

				function reflextion_populateAutoComplete(){
			var searchTerm = document.CatalogSearchForm.searchTerm.value.trim();
			if(searchTerm.length > 1){
				reflextion_populateAutoCompleteFromSrchTerm(searchTerm);
			}
			else{
				populateAutoCompleteWithoutSrchTerm();
			}
			retrieveCachedSuggestions();
		}

				function populateAutoCompleteWithoutSrchTerm(){
			var noOfProductsToBefetched = 6;
			if($("#noofproducts").length > 0){
				noOfProductsToBefetched = $("#noofproducts").val()*1;
			}

						var accessTokenJSON = $("#CONSTRUCTOR_KEY_AUTOSUGGEST").val();
			var userType = getCookie("WC_UserType");
			var userId = '';
			if(userType == 'R'){
				userId=getCookie("WC_UserId");
			}
			var trendingBrandsURL = "https://pwcdauseo-zone.cnstrc.com/recommendations/v1/pods/trending_brands?key="+accessTokenJSON+"&num_results=5&section=Brands";
			var trendingCategoriesURL = "https://pwcdauseo-zone.cnstrc.com/recommendations/v1/pods/trending_categories?key="+accessTokenJSON+"&num_results=5&section=Categories";
			var trendingProductsURL = "https://pwcdauseo-zone.cnstrc.com/recommendations/v1/pods/trending_products?key="+accessTokenJSON+"&num_results=10&section=Products";
			$.ajax(
					{
						url : trendingCategoriesURL,
						type: 'GET',
						beforeSend : function(xhr){ 
							xhr.setRequestHeader('Content-Type', 'application/json');     
						}, 
						success : function(dataVal) {
							var isNewEASession = getCookie('isNewEASession');
							if (isNewEASession!=null && isNewEASession == "yes" ){
								load_EAReflektion_autocomplete(dataVal,'');
							}else{
								load_Reflektion_autocomplete(dataVal,'');
								ReflektionHelperJS.bopusAreaRestrictionCheck();
							}
						},
						dataType : 'json',
						error : function(jqXHR, textStatus, errorThrown) { 
							console.log(" error populating auto complete");       
						}     
					}
				);
			$.ajax(
					{
						url : trendingBrandsURL,
						type: 'GET',
						beforeSend : function(xhr){ 
							xhr.setRequestHeader('Content-Type', 'application/json');     
						}, 
						success : function(dataVal) {
							var isNewEASession = getCookie('isNewEASession');
							if (isNewEASession!=null && isNewEASession == "yes" ){
								load_EAReflektion_autocomplete(dataVal,'');
							}else{
								load_Reflektion_autocomplete(dataVal,'');
								ReflektionHelperJS.bopusAreaRestrictionCheck();
							}
						},
						dataType : 'json',
						error : function(jqXHR, textStatus, errorThrown) { 
							console.log(" error populating auto complete");       
						}     
					}
				);

					}

				function reflextion_populateAutoCompleteFromSrchTerm(srchTerm){
			if(AUTOCOMPLETE_PREVIOUS_SEARCH_TERM == srchTerm){
				if(IS_AUTOCOMPLETE_DATA_FETCHED){
					$("#look-ahead").addClass("active");
				}
				return;
			}
			var noOfProductsToBefetched = 6;
			if($("#noofproducts").length > 0){
				noOfProductsToBefetched = $("#noofproducts").val()*1;
			}

						var accessTokenJSON = $("#CONSTRUCTOR_KEY_AUTOSUGGEST").val();
			var userType = getCookie("WC_UserType");
			var userId = '';
			if(userType == 'R'){
				userId=getCookie("WC_UserId");
			}
			var URL = "https://pwcdauseo-zone.cnstrc.com/autocomplete/"+srchTerm+"?key="+accessTokenJSON+"&num_results_Products=10&num_results_Search%20Suggestions=5&num_results_Brands=3&num_results_Categories=4";
			$.ajax(
					{
						url : URL,
						type: 'GET',
						beforeSend : function(xhr){ 
							xhr.setRequestHeader('Content-Type', 'application/json');     
						}, 
						success : function(dataVal) {
							var isNewEASession = getCookie('isNewEASession');
							if (isNewEASession!=null && isNewEASession == "yes" ){
								load_EAReflektion_autocomplete(dataVal,srchTerm);
							}else{
								load_Reflektion_autocomplete(dataVal,srchTerm);
								ReflektionHelperJS.bopusAreaRestrictionCheck();
							}
						},
						dataType : 'json',
						error : function(jqXHR, textStatus, errorThrown) { 
							console.log(" error populating auto complete");       
						}     
					}
				);


							}

				function load_Reflektion_autocomplete(jsonObject,searchTerm){
			IS_AUTOCOMPLETE_DATA_FETCHED = true;
			var isCategoryExists =false;
			var lowerCaseSearchTerm = searchTerm.toLowerCase();
			var htmlCategoryContentItemLevel = "";
			var htmlContent = "";
			$("#reflektion_autocomplete_brand_emptybox").addClass("hide");
			$("#reflektion_autocomplete_searchterm_emptybox").addClass("hide");
			var RFLK_SEE_ALL = $("#RFLK_SEE_ALL").val();
			var RFLK_SEE_ALL_TRENDING_PRODUCTS = $("#RFLK_SEE_ALL_TRENDING_PRODUCTS").val();
			var RFLK_TOP_PRODUCTS = $("#RFLK_TOP_PRODUCTS").val();
			var RFLK_TRENDING_PRODUCTS = $("#RFLK_TRENDING_PRODUCTS").val();
			var RFLK_RELATED_SEARCH = $("#RFLK_RELATED_SEARCH").val();
			var RFLK_TOP_BRANDS = $("#RFLK_TOP_BRANDS").val();
			var RFLK_TRENDING_CATEGORIES = $("#RFLK_TRENDING_CATEGORIES").val();
			var RFLK_TOP_CATEGORIES = $("#RFLK_TOP_CATEGORIES").val();
			var is_bopus_area_restriction_req = "";

						var categoryTrackingLisnk ="";
			if(searchTerm != ""){
				categoryTrackingLisnk ="PreviewSearch-_-TopCategories:";
				if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.sections) != 'undefined' && typeof(jsonObject.sections.Categories) != 'undefined' ){
					for(var i in jsonObject.sections.Categories){
						isCategoryExists = true;
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<li id='categoryItem_"+i+"' role='listitem' tabindex='-1'>";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<a manual_cm_sp='"+categoryTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.sections.Categories[i].value.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='"+formSearchPreviewUrl(document.domain+jsonObject.sections.Categories[i].data.url)+"' onmouseout='this.className=\"\"' "
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" title='"+jsonObject.sections.Categories[i].value+"'";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" id='category_autoSelectOption_"+i+"'>"
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+ jsonObject.sections.Categories[i].value.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+'</a></li>';
					}
				}
				if(isCategoryExists){
	 				htmlContent = "<div id='topCategoryResults'><div id='topCategoryResults_header'><strong>"+RFLK_TOP_CATEGORIES+"</strong>";
	 				htmlContent = htmlContent+"<div class='list_section'>";
	 				htmlContent = htmlContent+"<div title='Category' role='list'>";
	 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
	 				htmlContent = htmlContent+htmlCategoryContentItemLevel;
	 				htmlContent = htmlContent+"</ul></div></div></div></div>";
	 				$("#reflektion_autocomplete_category").html(htmlContent);
	 				$("#reflektion_autocomplete_category").show();
	 				$("#reflektion_autocomplete_category").addClass("show");
	 				$("#look-ahead").addClass("active");
	 			}else{
	 				if(searchTerm != ""){
		 				$("#reflektion_autocomplete_category").hide();
		 				$("#reflektion_autocomplete_category").removeClass("show");
		 				$("#reflektion_autocomplete_category").html("");
	 				}
	 			}
			}


									if(searchTerm == ""){
				categoryTrackingLisnk ="PreviewSearch-_-TrendingCategories:";
				if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.response) != 'undefined' && typeof(jsonObject.response.results) != 'undefined' && typeof(jsonObject.request)!= 'undefined' && jsonObject.request.section == 'Categories' ){
					for(var i in jsonObject.response.results){
						isCategoryExists = true;
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<li id='categoryItem_"+i+"' role='listitem' tabindex='-1'>";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<a manual_cm_sp='"+categoryTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.response.results[i].value.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='"+formSearchPreviewUrl(document.domain+jsonObject.response.results[i].data.url)+"' onmouseout='this.className=\"\"' "
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"  title='"+jsonObject.response.results[i].value+"'";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" id='category_autoSelectOption_"+i+"'>"
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+ jsonObject.response.results[i].value.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+'</a></li>';
					}
				}
				if(isCategoryExists){
	 				htmlContent = "<div id='topCategoryResults'><div id='topCategoryResults_header'><strong>"+RFLK_TRENDING_CATEGORIES+"</strong>";
	 				htmlContent = htmlContent+"<div class='list_section'>";
	 				htmlContent = htmlContent+"<div title='Category' role='list'>";
	 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
	 				htmlContent = htmlContent+htmlCategoryContentItemLevel;
	 				htmlContent = htmlContent+"</ul></div></div></div></div>";
	 				$("#reflektion_autocomplete_category").html(htmlContent);
	 				$("#reflektion_autocomplete_category").show();
	 				$("#reflektion_autocomplete_category").addClass("show");
	 				$("#look-ahead").addClass("active");
	 			}else{
	 				if(searchTerm != ""){
	 				$("#reflektion_autocomplete_category").hide();
	 				$("#reflektion_autocomplete_category").removeClass("show");
	 				$("#reflektion_autocomplete_category").html("");
	 				}
	 			}
			}
			var brandTrackingLisnk="PreviewSearch-_-TopBrands:";
			var isBrandExists =false;
			var htmlBrandContentItemLevel = "";
			htmlContent = "";
			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.sections) != 'undefined' && typeof(jsonObject.sections.Brands) != 'undefined' ){
				for(var i in jsonObject.sections.Brands){
					isBrandExists = true;
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<li id='brandItem_"+i+"' role='listitem' tabindex='-1'>";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<a manual_cm_sp='"+brandTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.sections.Brands[i].value.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='//"+document.domain+jsonObject.sections.Brands[i].data.url+"' onmouseout='this.className=\"\"' "
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" title='"+jsonObject.sections.Brands[i].value+"'";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" id='brand_autoSelectOption_"+i+"'>"
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+ jsonObject.sections.Brands[i].value.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+'</a></li>';
				}
			}
			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.response) != 'undefined' && typeof(jsonObject.response.results) != 'undefined' && typeof(jsonObject.request)!= 'undefined' && jsonObject.request.section == 'Brands' ){
				for(var i in jsonObject.response.results){
					isBrandExists = true;
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<li id='brandItem_"+i+"' role='listitem' tabindex='-1'>";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<a manual_cm_sp='"+brandTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.response.results[i].value.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='//"+document.domain+jsonObject.response.results[i].data.url+"' onmouseout='this.className=\"\"' "
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" title='"+jsonObject.response.results[i].value+"'";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" id='brand_autoSelectOption_"+i+"'>"
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+ jsonObject.response.results[i].value.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+'</a></li>';
				}
			}
			if(isBrandExists){
 				htmlContent = "<div id='topBrandResults'><div id='topBrandResults_header'><strong>"+RFLK_TOP_BRANDS+"</strong>";
 				htmlContent = htmlContent+"<div class='list_section'>";
 				htmlContent = htmlContent+"<div title='Brand' role='list'>";
 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
 				htmlContent = htmlContent+htmlBrandContentItemLevel;
 				htmlContent = htmlContent+"</ul></div></div></div></div>";
 				$("#reflektion_autocomplete_brand").html(htmlContent);
 				$("#reflektion_autocomplete_brand").show();
 				$("#reflektion_autocomplete_brand").addClass("show");
 				$("#look-ahead").addClass("active");
 			}else{
 				if(searchTerm != ""){
 				$("#reflektion_autocomplete_brand").hide();
 				$("#reflektion_autocomplete_brand").removeClass("show");
 				$("#reflektion_autocomplete_brand").html("");
 				}
 			}
			var relatedSearchesTrackingLisnk="PreviewSearch-_-RelatedSearches:";
			var isSearchTermExists =false;
			var htmlSearchTermContentItemLevel = "";
			htmlContent = "";
			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.sections) != 'undefined' && typeof(jsonObject.sections["Search Suggestions"]) != 'undefined' ){
				for(var i in jsonObject.sections["Search Suggestions"]){
					if(jsonObject.sections["Search Suggestions"][i].value.trim() !=""){
					isSearchTermExists = true;
					htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+"<li id='searchtermItem_"+i+"' role='listitem' tabindex='-1'>";
	 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+"<a manual_cm_sp='"+relatedSearchesTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.sections["Search Suggestions"][i].value.split(" ").join("")+"'   role='listitem' href='#' onmouseout='this.className=\"\"' "
	 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" onmouseover='SearchJS.enableAutoSelect(\""+i+"\");'  ";
	 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" onclick='clickTrackLink(this);SearchJS.selectAutoSuggest(this.title); return false;' title='"+jsonObject.sections["Search Suggestions"][i].value+"'";
	 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" id='searchterm_autoSelectOption_"+i+"'>"
	 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+ jsonObject.sections["Search Suggestions"][i].value;
					htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+'</a></li>';
					}
				}
			}		

						if(isSearchTermExists){
 				htmlContent = "<div id='topsearchtermResults'><div id='topsearchtermResults_header'><strong>"+RFLK_RELATED_SEARCH+"</strong>";
 				htmlContent = htmlContent+"<div class='list_section'>";
 				htmlContent = htmlContent+"<div title='Search Term' role='list'>";
 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
 				htmlContent = htmlContent+htmlSearchTermContentItemLevel;
 				htmlContent = htmlContent+"</ul></div></div></div></div>";
 				$("#reflektion_autocomplete_searchterm").html(htmlContent);
 				$("#reflektion_autocomplete_searchterm").show();
 				$("#reflektion_autocomplete_searchterm").addClass("show");
 				$("#look-ahead").addClass("active");
 			}else{
 				if(searchTerm != ""){
 				$("#reflektion_autocomplete_searchterm").hide();
 				$("#reflektion_autocomplete_searchterm").removeClass("show");
 				$("#reflektion_autocomplete_searchterm").html("");
 				}
 			}

								var productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						var isDataExistrs=false;
					if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.sections) != 'undefined' && typeof(jsonObject.sections.Products) != 'undefined' && typeof(jsonObject.sections.Products[0]) != 'undefined'){
						var htmlContentProduct = "<div class='row'>";

												if(searchTerm == ""){
							productSearchesTrackingLisnk="PreviewSearch-_-TrendingProducts:";
			 			htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TRENDING_PRODUCTS+"</strong></div></div>";
						}else{
							productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TOP_PRODUCTS+"</strong></div></div>";	
						}
			 			htmlContentProduct = htmlContentProduct+"<div class='row'>";

			 						 							 			for(var i in jsonObject.sections.Products){

			 							 				is_bopus_area_restriction_req = "";

			 							 				isDataExistrs=true;
			 				htmlContentProduct = htmlContentProduct+'<div manual_cm_sp="'+productSearchesTrackingLisnk+((i*1)+1)+'-_-'+jsonObject.sections.Products[i].data.id.split(" ").join("")+'"  class="col-4 prod-tile-rfl" onclick="clickTrackLink(this);location.href=\'//'+document.domain+jsonObject.sections.Products[i].data.url+'\'">';
			 				if(typeof(jsonObject.sections.Products[i].data.listprice) != 'undefined' && 
			 						jsonObject.sections.Products[i].data.listprice > jsonObject.sections.Products[i].data.offerprice){
			 					htmlContentProduct = htmlContentProduct+'<img class="badge" src="/wcsstore/PetcoStore/img/ON_SALE.png"/>';
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-4-sm text-center " >';

			 											var ProductImageURL = jsonObject.sections.Products[i].data.image_url.replace("/wcsstore/PetcoCAS/","");
							var imagePresetSrc = ProductImageURL + '?$tile-recommendations$';
							var imagePresetSrcMobile = ProductImageURL + '?$PDP-thumbnail$';
							if (isCloudniaryEnabled()) {
								imagePresetSrc  = ProductImageURL.replace('f_auto,q_auto,w_190', 'f_auto,q_auto,t_tile-recommendations,t_Thumbnail');
								imagePresetSrcMobile  = ProductImageURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_PDP-thumbnail');
							}
			 				htmlContentProduct = htmlContentProduct+'<img class="desktop-only rfk-img-responsive" src="'+imagePresetSrc+'" title="'+jsonObject.sections.Products[i].value+'">';
			 				htmlContentProduct = htmlContentProduct+'<img class="mobile-only rfk-img-responsive" src="'+imagePresetSrcMobile+'" title="'+jsonObject.sections.Products[i].value+'">';
			 				htmlContentProduct = htmlContentProduct+'</div>';

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-8-sm text-left product-name" >';
			 				var brandName = jsonObject.sections.Products[i].data.PTC_OMNI_BRAND_PRIMARY;
			 				if(typeof(brandName) != 'undefined' && jsonObject.sections.Products[i].data.PTC_OMNI_BRAND_PRIMARY.indexOf(brandName) ==0){
			 					htmlContentProduct = htmlContentProduct+"<strong>"+brandName+"</strong>";
			 					htmlContentProduct = htmlContentProduct+jsonObject.sections.Products[i].value.replace(brandName,"");
			 				}else{
			 					htmlContentProduct = htmlContentProduct+jsonObject.sections.Products[i].value;
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'</div>';
			 				if(typeof(is_bopus_area_restriction_req) != 'undefined' && is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
			 					htmlContentProduct = htmlContentProduct+'<div class="col-8-sm mobile-only hideBopusAreaRestriction product-pricing rfk-product-pricing-mobile" >';
			 				}else{
			 					htmlContentProduct = htmlContentProduct+'<div class="col-8-sm mobile-only product-pricing rfk-product-pricing-mobile" >';
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">$'+jsonObject.sections.Products[i].data.offerprice+'</span>';
			 				if(typeof(jsonObject.sections.Products[i].data.listprice) != 'undefined' && 
			 						jsonObject.sections.Products[i].data.listprice*1 > jsonObject.sections.Products[i].data.offerprice){

			 								 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was $'+jsonObject.sections.Products[i].data.listprice+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';			 				

			 							 				if(typeof(is_bopus_area_restriction_req) != 'undefined' &&  is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
			 					htmlContentProduct = htmlContentProduct+'<div class="col-12  text-center desktop-only product-pricing hideBopusAreaRestriction" >';
			 				}else{
			 					htmlContentProduct = htmlContentProduct+'<div class="col-12  text-center desktop-only product-pricing" >';
			 				}
			 				var displayPrice="";
			 				if(typeof(jsonObject.sections.Products[i].data.offerprice)!= 'undefined'){
			 					displayPrice=jsonObject.sections.Products[i].data.offerprice;
			 					if(typeof(displayPrice)!= "string")
			 						displayPrice = displayPrice.toString();
			 					if(displayPrice.indexOf("$")==-1)
			 						displayPrice="$"+displayPrice;
			 				}
			 				else if( typeof(jsonObject.sections.Products[i].data.listprice)!= 'undefined'){
			 					displayPrice=jsonObject.sections.Products[i].data.listprice;
			 				}
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">'+displayPrice+'</span>';
			 				if(typeof(jsonObject.sections.Products[i].data.listprice) != 'undefined' && 
			 						jsonObject.sections.Products[i].data.listprice.replace > jsonObject.sections.Products[i].data.offerprice){
			 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was $'+jsonObject.sections.Products[i].data.listprice+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 			}

					 			htmlContentProduct = htmlContentProduct+"</div>";
			 			htmlContentProduct =  htmlContentProduct+"<div class='row desktop-only'>";
			 			if(searchTerm == ""){

							}else{
								htmlContentProduct = htmlContentProduct+'<div class="col-2">&nbsp;</div><div class="col-8 text-center"><a href="javascript:document.CatalogSearchForm.submit()" class="btn btn-primary margin-bottom-sm btn-full" role="button">'+RFLK_SEE_ALL+'</a></div><div class="col-2"></div></div>';	
							}

			 									}else{
							if(searchTerm != ""){
			 				$("#productSuggestionResults_div").html("");
			 				$("#productSuggestionResults_div").hide();
			 				$("#productSuggestionResults_div").removeClass("show");
							}
			 			}
			 			if(isDataExistrs){
			 				$("#productSuggestionResults_div").show();
			 				$("#productSuggestionResults_div").addClass("show");
			 				$("#productSuggestionResults_div").html(htmlContentProduct);
			 				$("#look-ahead").addClass("active");
			 			}
						$("#reflektion_AutoCompleteList").addClass("show");
						$("#reflektion_AutoCompleteList").removeClass("hide");
						$("#reflektion_AutoCompleteList_empty").addClass("hide");
						$("#reflektion_AutoCompleteList_empty").removeClass("show");

			 						 			var isMobile = window.matchMedia("(max-width: 768px)").matches;
			 			if(!isMobile){
			 				setTimeout(function(){$(".prod-tile-rfl .product-name").dotdotdot();},25);
			 			}



			 						 										 			 var widthOfWindows = $(window).width()*0.50;
			 			if(($("#SimpleSearchForm_SearchTerm").width()*2) < widthOfWindows){
			 				widthOfWindows = $("#SimpleSearchForm_SearchTerm").width()*2;
			 			}
			 		    var heightOfWIndows = window.innerHeight-$("#header").height();
			 		   if($("#search.search.persist-active.active").length >0){
			 			  heightOfWIndows = heightOfWIndows - $("#search.search.persist-active.active").height();
			 		   }
			 			if(!isMobile){
			 				if($("#productSuggestionResults_div").height() > $("#infoPart").height()){
			 					$("#infoPart").height($("#productSuggestionResults_div").height());
			 				}else{
			 					$("#productSuggestionResults_div").height($("#infoPart").height());
			 				}
			 				if(($("#infoPart").height()+5) < heightOfWIndows){
			 					heightOfWIndows= $("#infoPart").height()+5;
			 				}
			 			    $("#look-ahead").width(widthOfWindows);
			 			    $("#look-ahead").height(heightOfWIndows);
			 			    $("#look-ahead").css("maxHeight",heightOfWIndows+"px");
			 				if($("#search.search.persist-active.active").length >0){
				 				$("#look-ahead").css("marginLeft","-"+($("#look-ahead").width()-($("#search.search.persist-active.active").width()))+"px");

				 								 			}else{
				 				$("#look-ahead").css("marginLeft","0px");
				 			}
			 			}else{

			 				 			 				 $("#look-ahead").width($(window).width());
				 			    $("#look-ahead").height((window.innerHeight-($("#header").height()+$("#search").height()))/2);
				 			   $("#look-ahead").css("maxHeight",(window.innerHeight-($("#header").height()+$("#search").height()))/2+"px");
			 			}
						if(lowerCaseSearchTerm == ""){
							$("#reflektion_autocomplete_searchterm").html($("#reflektion_autocomplete_searchterm_emptybox").html());
						}else{

														if(!$("#reflektion_autocomplete_category").hasClass("show")
									&& !$("#reflektion_autocomplete_brand").hasClass("show")
									&& !$("#reflektion_autocomplete_searchterm").hasClass("show")
									&& !$("#productSuggestionResults_div").hasClass("show")
									&& searchTerm != ""){
								$("#reflektion_AutoCompleteList_empty").addClass("show");
								$("#reflektion_AutoCompleteList_empty").removeClass("hide");
								$("#reflektion_AutoCompleteList").addClass("hide");
								$("#reflektion_AutoCompleteList").removeClass("show");

																if(!isMobile){
								$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm+"\"</strong>")
								}else{
									$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm.substring(0,150)+"\"</strong>")
								}
								$("#look-ahead").height($("#reflektion_AutoCompleteList_empty").height()*1.20);
							}
						}
		}


						function retrieveCachedSuggestions() {
			if(!ConstructorioHelperJS.retrievedCachedSuggestions) {

								$.ajax({
					  method: "GET",
					  url: CachedSuggestionsURL,
					  dataType: "script"
					});

				 			}
		}
		function setUserContextFromLocalStorage() {				
			var oStores = JSON.parse(localStorage.getItem('petcostores'));
			if(oStores != undefined && oStores != null && Object.keys(oStores).length > 0 ){
				var oPetcostores = oStores.petcostores;
				if(typeof(oPetcostores) != "undefined"){
					var storeVal = JSON.parse(oPetcostores);				
					if(storeVal.length > 1){
					 	for(var i=0;i<storeVal.length;i++){ 
					 		if( typeof(storeVal[i].isPreferred)== "undefined" || storeVal[i].isPreferred != "Y"){
					 			USER_CONTEXT.zipCode = storeVal[i].ZIPCODE;
					 			USER_CONTEXT.state = storeVal[i].STATE;
					 			USER_CONTEXT.country = 'US';	
					 			break;
							}
					 	}				 	
					}
				}			
			}
		}
		function setRfkRecommendationSKU(skuPartNumber){
			RECOMMENDATION_PDP_SKU = skuPartNumber;
		}
		function rfkRecommendation_init(rfkWidgetId){
			if(enableRfkRecommendation()) {
				var recommendationCall = setInterval(function(){ 				
					if(IS_KEY_RETRIVED){
						rfkPopulateRecommendation(rfkWidgetId);
						clearInterval(recommendationCall);
						if(null != rfkRecommendationRequest && null != rfkRecommendationRequest.data.filter){
							delete rfkRecommendationRequest.data.filter;
						}
					}
				}, 100);
			}


							}

				function triggerWidgetCall(rfkWidgetId,dataVal,textStatus,rfkRecommendationWidget,titleWidgetName ){
			try{
				widgetsFiredForRecommetnaions.push(rfkWidgetId);
				var isAllWidgetCompleted = true;
				$("div[rfk_widget_id]").each(function(i,obj){
					if(!widgetsFiredForRecommetnaions.includes($(obj).attr("rfk_widget_id"))){
						isAllWidgetCompleted = false;
					}

									})
				if(textStatus === 'success'){
					var responseJSON  = dataVal.responseJSON;
					var jsonObject;
					if(titleWidgetName == ""){
						jsonObject = responseJSON;
					}else{
						for(var i in responseJSON.batch){
							var widgetId = responseJSON.batch[i].widget.rfkid;
							if(widgetId == rfkRecommendationWidget ){
								jsonObject = responseJSON.batch[i];
							}						
						}
					}


															if(jsonObject){
						var content  = jsonObject.content;
						if(typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' && typeof(jsonObject.content.product.value) != 'undefined'){
							var productList = jsonObject.content.product.value;
							for( var inst in productList){
								for(var swatchid in productList[inst].swatch){
									var productIdForSwatch =  productList[inst].swatch[swatchid].sku_uid;
									if(!productIdToFetchPrice.includes(productIdForSwatch)){
										productIdToFetchPrice.push(productIdForSwatch);
									}
								}
							}
						}
					}
				}

					if(isAllWidgetCompleted && Object.getOwnPropertyNames(solrProductPriceMap).length > 0){
					isAllWidgetCompleted = false;					
					for(var ids in productIdToFetchPrice){						
						if(typeof(solrProductPriceMap[productIdToFetchPrice[ids]]) === 'undefined'){
							isAllWidgetCompleted = true;
							break;
						}
					}
					if(!isAllWidgetCompleted){
						updateSolrPrice();
					}

									}




																if(isAllWidgetCompleted && !isCallInitialtedForSOlr){
					var fetchPrceChange = {};
					var paramFetchPrice = "productIds="+ productIdToFetchPrice.toString();
					$.ajax({
						url : getAbsoluteURL()+"PetcoFetchPriceFromSolr",
						type: 'POST',
						data: paramFetchPrice,
						beforeSend : function(xhr){ 
							isCallInitialtedForSOlr = true;
						}, 
						success : function(dataVal) {
								for( var priceData in dataVal){
									var producTidval = dataVal[priceData].productId;
									var listprice_USD = dataVal[priceData].listprice_USD;
									var price_USD = dataVal[priceData].price_USD;
									var rd_price_USD = 	dataVal[priceData].rd_price_USD;

																		var priceMapDetails = {};
									priceMapDetails["listprice_USD"] = listprice_USD;
									priceMapDetails["price_USD"] = price_USD;
									priceMapDetails["rd_price_USD"] = rd_price_USD;
									solrProductPriceMap[producTidval]= priceMapDetails;

																		}
								updateSolrPrice();
						},
						complete: function(){
							isCallInitialtedForSOlr = false;
						},
						dataType : 'json',
						timeout : 5000
					});

									}
			}catch (error) {
				console.log(error)
			}
		}

				function triggerWidgetCallInBatch(dataVal, textStatus, recommendationDataForRfkCall){

									try{

								if(textStatus === 'success'){

										var rfkResponseForRecommendationCall  = dataVal.responseJSON;
					var productIdToFetchPriceInBatch = [];
					var isPriceFromSolrCallNeeded = false;

										$.each( recommendationDataForRfkCall.widgetArr , function( index, recommendationWidget ){

												var jsonObject={};				
						var rfkRecWidgetName = recommendationWidget.rfkWidgetName;

												for(var i in rfkResponseForRecommendationCall.batch){					
								var widgetId = rfkResponseForRecommendationCall.batch[i].widget.rfkid;
								if(widgetId == rfkRecWidgetName ){
										jsonObject = rfkResponseForRecommendationCall.batch[i];
										break;
								}					
						}

												if(jsonObject){
							var content  = jsonObject.content;
							if(typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' && typeof(jsonObject.content.product.value) != 'undefined'){
								var productList = jsonObject.content.product.value;
								for( var inst in productList){
									for(var swatchid in productList[inst].swatch){
										var productIdForSwatch =  productList[inst].swatch[swatchid].sku_uid;
										if(!productIdToFetchPriceInBatch.includes(productIdForSwatch)){
											productIdToFetchPriceInBatch.push(productIdForSwatch);
										}
									}
								}
							}
						}

												if(Object.getOwnPropertyNames(solrProductPriceMap).length > 0){
								for(var ids in productIdToFetchPriceInBatch){		
										if(typeof(solrProductPriceMap[productIdToFetchPriceInBatch[ids]]) === 'undefined'){
												isPriceFromSolrCallNeeded = true;
												break;
										}
								}					
						}
						else{
							isPriceFromSolrCallNeeded = true;
						}
					});

										if(isPriceFromSolrCallNeeded && !isCallInitialtedForSOlr){

												var paramFetchPrice = "productIds="+ productIdToFetchPriceInBatch.toString();
						$.ajax({
							url : getAbsoluteURL()+"PetcoFetchPriceFromSolr",
							type: 'POST',
							data: paramFetchPrice,
							beforeSend : function(xhr){ 
								isCallInitialtedForSOlr = true;
							}, 
							success : function(dataVal) {
									for( var priceData in dataVal){
										var producTidval = dataVal[priceData].productId;
										var listprice_USD = dataVal[priceData].listprice_USD;
										var price_USD = dataVal[priceData].price_USD;
										var rd_price_USD = 	dataVal[priceData].rd_price_USD;

																				var priceMapDetails = {};
										priceMapDetails["listprice_USD"] = listprice_USD;
										priceMapDetails["price_USD"] = price_USD;
										priceMapDetails["rd_price_USD"] = rd_price_USD;
										solrProductPriceMap[producTidval]= priceMapDetails;											
									}
									updateSolrPrice();
							},
							complete: function(){
								isCallInitialtedForSOlr = false;
							},
							dataType : 'json',
							timeout : 5000
						});
					}
					else{
						updateSolrPrice();
					}					
				}

							} catch (error) {
				console.log(error)
			}

					}

				function updateSolrPrice(){
			try{
				var itemIdsList = $('input[id$="productId-tagging"]');
				if(typeof(solrProductPriceMap) === 'undefined'){
					return;
				}
				$(itemIdsList).each(function(i,obj){
					if(obj.value != ""){
						var idPrefeix = obj.id.replace("-productId-tagging","");
						var productId = obj.value;
						var productObject = solrProductPriceMap[productId];
						if(typeof(productObject) != 'undefined'){
							var priceUSD = productObject["price_USD"];
							var listpriceUSD = productObject["listprice_USD"];
							var rdPriceUSD = productObject["rd_price_USD"];
							if(priceUSD != ""){
								var rfkwidgetControlParam = "";
								var rfkwidgetId = $("#rfkWidgetId").val();
								var widgetControlParamVar = "#" + rfkwidgetId + "-" + "rfkwidgetControlParam";
							   	if($(widgetControlParamVar).length > 0){
									rfkwidgetControlParam = $(widgetControlParamVar).val();				
								}
								var offerPriceVar = "#"+idPrefeix + "-price-promo";
								if($(offerPriceVar).length > 0){
									if(rfkwidgetControlParam == 'RD_DETAILS_PAGE' && rdPriceUSD != ""){
										$(offerPriceVar).html(rdPriceUSD);
								   	}
									else{
										$(offerPriceVar).html(priceUSD);
									}	
								}
								var rfkProductListPriceTaggingElement = "#"+  idPrefeix + "-productListPrice-tagging";                                                
                                if ($(rfkProductListPriceTaggingElement)&& listpriceUSD != "" ) {
                                    $(rfkProductListPriceTaggingElement).val(listpriceUSD);
                                }
								if(rfkwidgetControlParam != 'RD_DETAILS_PAGE'){
									var listPriceVar = "#"+idPrefeix + "-price-crossout";
									if(typeof(listpriceUSD) != 'undefined' && listpriceUSD != "" && 
												((listpriceUSD.replace("$","")*1) > priceUSD.replace("$","")*1)){
										if($(listPriceVar).length > 0){
											$(listPriceVar).html('was ' + listpriceUSD);
										}					
									}else{
										if($(listPriceVar).length > 0){
											$(listPriceVar).html("");
										}		
									}
									var rdPriceDiv = "#"+idPrefeix + "-price-rd-val";
									if($(rdPriceDiv).length > 0 && rdPriceUSD != ""){					
										$(rdPriceDiv).html(rdPriceUSD);
									}else if($(rdPriceDiv).length > 0 && rdPriceUSD == ""){
										$(rdPriceDiv).html("");
									}
								}
							}
						}


										}
				});
                if (null != $('#adobeDataLayerEnabled')
                        && undefined != $('#adobeDataLayerEnabled')
                        && $('#adobeDataLayerEnabled').val() == 'true') {
                    var testWidgetControlParam = "";
                    var testWidgetId = $("#rfkWidgetId").val();
                    var testWidgetControlParamVar = "#" + testWidgetId + "-" + "rfkwidgetControlParam";
                    if($(testWidgetControlParamVar).length > 0){
                    testWidgetControlParam = $(testWidgetControlParamVar).val();
                    }
                    if(testWidgetControlParam == 'RD_DETAILS_PAGE'){
                        var adobeDataLayerRfkRecommendationTriggeredArr = [];
                        if ("IntersectionObserver" in window){
                            var n = new IntersectionObserver(function (e, t) {
                                e.forEach(function (e) {
                                    if (e.isIntersecting) {
                                        console.log("e.target.id : " + e.target.id);
                                        if(!adobeDataLayerRfkRecommendationTriggeredArr.includes(e.target.id)){
                                            adobeDataLayerRfkRecommendationTriggeredArr.push(e.target.id);
                                            adobeBuildReflektionWidget(e.target.id);
                                        }
                                    }
                                });
                            });

                                    const rfkrecomendationList = document.querySelectorAll(".rfk_recommendation_wrapper");
                            var rfkIndex = 0;
                            console.log("rfkrecomendationList : " + rfkrecomendationList);
                            rfkrecomendationList.forEach(function (rfkrecomendation){
                                console.log("Iteration : " + rfkrecomendation);
                                n.observe(rfkrecomendation);
                                if(null!= rfkrecomendationList[rfkIndex].id && undefined != rfkrecomendationList[rfkIndex].id){
                                    var modulePosRfkId = rfkrecomendationList[rfkIndex].id.split("_").pop();
                                    var rfkModulePosTaggingElement =  modulePosRfkId +  "-rfkModulePosition";
                                    rfkIndex++;
                                    if (document.getElementById(rfkModulePosTaggingElement) ){ 
                                        document.getElementById(rfkModulePosTaggingElement).value = rfkIndex;
                                        }
                                }
                                });
                            }
                    }
                }                
			}catch (error) {
				console.log(error)
			}

					}

				function logErrorFromReflektion(jqXHR, errorType, exception){
			if(errorType == 'timeout'){
				console.log("Reflektion API request timed out");
			} else {
				var responseText = jQuery.parseJSON(jqXHR.responseText);
				console.log("Reflektion error code:" + responseText.err);
				console.log("Reflektion error message:" + responseText.msg);
			}			
		}

				function boldString(productName, brand){
			var regex = new RegExp(brand, 'ig');
			return productName.replace(regex, '<strong>'+brand+'</strong>');
		}		

				function loadRfkRecommendationWidgets(jsonObjectMain, rfkWidgetId, mainWidgetName, titleWidgetName){
			if(recommendationParsedSkuDetails[rfkWidgetId] != undefined) {
				delete recommendationParsedSkuDetails[rfkWidgetId];				
			}
			var jsonObject={};
			var jsonObjectTitle={};
			if(titleWidgetName == ""){
				jsonObject = jsonObjectMain;
			}else{
				for(var i in jsonObjectMain.batch){
					var widgetId = jsonObjectMain.batch[i].widget.rfkid;
					if(widgetId == mainWidgetName ){
						jsonObject = jsonObjectMain.batch[i];
					}else if(widgetId == titleWidgetName){
						jsonObjectTitle  = jsonObjectMain.batch[i];
					}
					var variationId = jsonObjectMain.batch[i].widget.variation_id;
                    var experimentId = jsonObjectMain.batch[i].widget.experiment_id;
                    var experimentBucket = jsonObjectMain.batch[i].widget.experiment_bucket;

                                        var rfkVariationIdTaggingElement =  rfkWidgetId +  "-rfkVariationId-tagging";
                    if (document.getElementById(rfkVariationIdTaggingElement) && undefined != variationId) { document.getElementById(rfkVariationIdTaggingElement).value = variationId; }
                    var rfkExperimentIdTaggingElement =  rfkWidgetId +  "-rfkExperimentId-tagging";
                    if (document.getElementById(rfkExperimentIdTaggingElement) && undefined != experimentId) { document.getElementById(rfkExperimentIdTaggingElement).value = experimentId; }                
                    var rfkExperimentBucketTaggingElement =  rfkWidgetId +  "-rfkExperimentBucket-tagging";
                    if (document.getElementById(rfkExperimentBucketTaggingElement) && undefined != experimentBucket) { document.getElementById(rfkExperimentBucketTaggingElement).value = experimentBucket; 
                    }
                }
			}

						if(typeof(jsonObject.content) == 'undefined' || typeof(jsonObject.content.product) == 'undefined'){
				return;
			}

						var elementIdPrefix = "#" + rfkWidgetId + "-";
			$('select[id^="'+rfkWidgetId+'-"]').remove();
			var widgetTitleVar = elementIdPrefix + 'widgetTitle';
			var carouselPrev = elementIdPrefix + 'prev';
			var carouselNext = elementIdPrefix + 'next';
			var rfkEnableSkuSelectionVar = elementIdPrefix + "rfkEnableSkuSelection";
			var rfkEnableSkuSelection;
			if($(rfkEnableSkuSelectionVar).length > 0){
				rfkEnableSkuSelection = $(rfkEnableSkuSelectionVar).val();
			}	
			if(typeof(jsonObjectTitle) != 'undefined' && typeof(jsonObjectTitle.appearance) != 'undefined'
				&& typeof(jsonObjectTitle.appearance.variables) != 'undefined' && typeof(jsonObjectTitle.appearance.variables.title) != 'undefined'){
				var classes = jsonObjectTitle.appearance.css_names;
				$(classes).each(function(i,obj){
					$(widgetTitleVar).addClass(obj);
				})
				var variables = jsonObjectTitle.appearance.variables;
				var text_color = variables["text-color"].value;
				if(text_color != ""){
					$(widgetTitleVar).css( "color", text_color);
				}

								var title = variables.title.value;
				if(title != ""){
					$(widgetTitleVar).html(title);
				}
			}


									var recommendedSkuCount =  parseInt(jsonObject.n_item);
			if(recommendedSkuCount > 0) {
				$(widgetTitleVar).show();			
				var definingAttributesCount = 0;
				for(var productIndex in jsonObject.content.product.value){
					elementIndex = parseInt(productIndex) + 1;				
					prodMainDiv = elementIdPrefix + elementIndex;
					$(prodMainDiv).show();	
					parseProductDetails(jsonObject.content.product.value[productIndex], rfkWidgetId, rfkEnableSkuSelection);
					var productPartNumber = jsonObject.content.product.value[productIndex].prod_partnumber;
					var selectedSwatch = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].selected_swatch;
					renderProductDetails(rfkWidgetId, elementIndex, selectedSwatch, productPartNumber, false);	
				}

								showOrHideContainer(rfkWidgetId, true);

								if(recommendedSkuCount > 3) {
					if($(carouselPrev).length > 0) {
						$(carouselPrev).css({'display':'block'})
					}
					if($(carouselNext).length > 0) {
						$(carouselNext).css({'display':'block'})
					}					
				}

							} else {
			}
		}

				function showOrHideContainer(cioWidgetId, showFlag) {
			var elementIdPrefix = cioWidgetId + "-";
			var widgetParentContainerField =  '#'+cioWidgetId+"-parent";			
			if($(widgetParentContainerField).length > 0) {
				var containerParent =  $(widgetParentContainerField).val();				
				var containerId;
				if(containerParent.length > 0) {
					containerId = '#container_rfk_recommendation_'+ containerParent;					
					if(showFlag == true) {
						$(containerId).show();
					} else {
						$(containerId).hide();
					}					

									}
			}		
		}


						function renderProductDetails(cioWidgetId, elementIndex, selectedSwatch, productPartNumber, isRefreshWidget){
			var ciowidgetControlParam = "";
			var widgetControlParamVar = "#" + cioWidgetId + "-" + "ciowidgetControlParam";
		   	if($(widgetControlParamVar).length > 0){
				ciowidgetControlParam = $(widgetControlParamVar).val();				
			}
		   	var parentPage = "#" + cioWidgetId + "-" + "parent";
		   	if($(parentPage).length > 0 && $(parentPage).val()=='RDDETAILS'){
				ciowidgetControlParam = "RD_DETAILS_PAGE";				
			}
			var isfromComboBoxFlag = false;

						var cioEnableSkuSelection;
			var cioEnableAddToCart;
			var ciowidgetName = "";
			var widgetNameVar = "#" + cioWidgetId + "-" + "cioWidgetName";
		   	if($(widgetNameVar).length > 0){
		   		ciowidgetName = $(widgetNameVar).val();				
			}
			var productName = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].name;	
			var brand = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].brand;
			var selectedSkuPartNumber = productPartNumber;
			var imgURL = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].image_url;
			var priceUSD = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].price_USD;
			var catentryId = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].catentryId;
			var listpriceUSD =  recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].listprice_USD;
			var rdPriceUSD = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].rd_price_USD;
			var reviewRating = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].review_rating;
			var isRDEligible = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].rd_eligible;
			var definingAttributesCount = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].defining_attr_count;
			var pdpURL = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].url;
			var personalizedItemFlag = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].personalizedItemFlag;
			var rxFoodIndicator = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].rxFoodIndicator;
			var rxPharmaIndicator = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].rxPharmaIndicator;
			var inStoreOnlyIndicator = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].inStoreOnlyIndicator;
			var itemId = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].itemId;
			var category = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].category;
			var bopusIndicator = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].bopusIndicator;;
			var is_bopus_area_restriction_req = "";
			var elementIdPrefix = "#" + cioWidgetId + "-";			
			var clsLoadingelementIdPrefix = "#clsLoading-" + cioWidgetId + "-";


						var cioEnableAddToCartVar = elementIdPrefix + "cioEnableAddToCart";	
			if($(cioEnableAddToCartVar).length > 0){
				cioEnableAddToCart = $(cioEnableAddToCartVar).val();
			}

						if(isRefreshWidget == false) {
				var prodMainDiv = elementIdPrefix + elementIndex;	
				var clsLoadingprodMainDiv = clsLoadingelementIdPrefix +elementIndex;
				var prodNameVar = elementIdPrefix + elementIndex + "-name-link";

							$(prodMainDiv).show();
				$(clsLoadingprodMainDiv).hide();
				if($(prodNameVar).length > 0){
					$(prodNameVar).click(function() {
						location.href = pdpURL;
					});					
					if(brand != undefined && brand != "") {
						formattedName = boldString(productName, brand);							
					} else {
						formattedName = productName;
					}						
					$(prodNameVar).html(formattedName);
					$(prodNameVar).attr('data-cnstrc-item-id',itemId);
					$(prodNameVar).attr('data-cnstrc-variation-id',productPartNumber);
					$(prodNameVar).attr('data-cnstrc-strategy-id',ciowidgetName);
					$(prodNameVar).attr('data-cnstrc-item-name',productName);
					$(prodNameVar).attr('data-cnstrc-category-id',category);
					if($(prodNameVar).css("overflow-wrap") != "break-word"){
						$(prodNameVar).dotdotdot();
					}
				}	
				showReviewRating(cioWidgetId, elementIndex, productPartNumber);				
			}


												var priceRDDIvTMP =  elementIdPrefix + elementIndex + "-price-rd";
			var priceDIvTMP =  elementIdPrefix + elementIndex + "-price";
			if(typeof(is_bopus_area_restriction_req) != 'undefined' && is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
				$(priceRDDIvTMP+".product-pricing").addClass('hideBopusAreaRestriction');
				$(priceDIvTMP+".product-pricing").addClass('hideBopusAreaRestriction');
			}else{
				$(priceRDDIvTMP+".product-pricing").removeClass('hideBopusAreaRestriction');
				$(priceDIvTMP+".product-pricing").removeClass('hideBopusAreaRestriction');
			}
			var imageVar = elementIdPrefix + elementIndex + "-img";
			if($(imageVar).length > 0){
				if($(imageVar+".verticalImage_rfk").length > 0){

										var imagePresetSrc =  imgURL + '?$tile-recommendations$';
					if(ciowidgetControlParam == 'PDP_ATC_MODAL') {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="javascript:trackATCInterstitailClick(\'modal_prod_rec_click\'); return true;">' + '<img class="img-responsive"  src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');	
					} else {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="clickTrackLink(this);adobeClickReflektionWidget(this);" adobe_manual_cm_sp="recommeded for you | reflektion product" data-cnstrc-item-id="'+itemId+'"data-cnstrc-variation-id="'+productPartNumber+'" data-cnstrc-strategy-id="'+ciowidgetName+'" data-cnstrc-item-name="'+productName+'" data-cnstrc-category-id="'+category+'">' + '<img class="img-responsive"  src="'+ imagePresetSrc + '" title="' + productName +'">' + '</a>'); 

											}					
				}else{
					var imagePresetSrc =  imgURL + '?$PLP-item-large$';
					if (isCloudniaryEnabled()) {
						imagePresetSrc = imgURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_PLP-item-large');
					} 
					if(ciowidgetControlParam == 'PDP_ATC_MODAL') {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="javascript:trackATCInterstitailClick(\'modal_prod_rec_click\');return true;">' + '<img src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');
					} else {
						 $(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="clickTrackLink(this);adobeClickReflektionWidget(this);" adobe_manual_cm_sp="recommeded for you | reflektion product">' + '<img src="'+ imagePresetSrc + '" title="' + productName +'">' + '</a>');					  
					}					
				}						
			}

						var showPrice = true;
			if (inStoreOnlyIndicator != undefined && inStoreOnlyIndicator != null && inStoreOnlyIndicator.toLowerCase() == 'yes'){
				if(bopusIndicator == undefined || bopusIndicator == null || bopusIndicator.toLowerCase() != 'yes') {
					showPrice = false;
				}				
			}
			if(showPrice) {
				var offerPriceVar = elementIdPrefix + elementIndex + "-price-promo";
				if($(offerPriceVar).length > 0){
					if(ciowidgetControlParam == 'RD_DETAILS_PAGE' && rdPriceUSD != ""){
						$(offerPriceVar).html('$'+rdPriceUSD);
						if(isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes'){
							var rdLogo = elementIdPrefix + elementIndex + "-price-rdrfk-logo";
							$(rdLogo).removeClass('hide');
						}
					}
					else{
						$(offerPriceVar).html('$'+priceUSD);
						if(ciowidgetControlParam == 'RD_DETAILS_PAGE' && isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes'){
							var rdLogo = elementIdPrefix + elementIndex + "-price-rdrfk-logo";
							$(rdLogo).removeClass('hide');
						}
					}
				}
				if(ciowidgetControlParam != 'RD_DETAILS_PAGE'){
					var listPriceVar = elementIdPrefix + elementIndex + "-price-crossout";
					if(typeof(listpriceUSD) != 'undefined' && 
								((listpriceUSD*1) > priceUSD*1)){
						if($(listPriceVar).length > 0){
							$(listPriceVar).html('was $' + listpriceUSD);
						}					
					}

										var rdPriceVar = elementIdPrefix + elementIndex + "-price-rd";
					var rdPriceDiv = elementIdPrefix + elementIndex + "-price-rd-val";
					var rdLogo = elementIdPrefix + elementIndex + "-price-rd-logo";
					if(isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes') {					
						if($(rdPriceVar).length > 0){					
							$(rdPriceDiv).html('$'+rdPriceUSD);
							$(rdPriceVar).show();
						} 
					} else {
						$(rdPriceDiv).html('');
						$(rdLogo).html('');		
						$(rdLogo).removeClass('rd-logo');
					}
				}
			} else {
				var rdPriceVar = elementIdPrefix + elementIndex + "-price-rd";
				var rdPriceDiv = elementIdPrefix + elementIndex + "-price-rd-val";
				var rdLogo = elementIdPrefix + elementIndex + "-price-rd-logo";
				$(rdPriceDiv).html('');
				$(rdLogo).html('');		
				$(rdLogo).removeClass('rd-logo');
			}
			var productNameTaggingElement =  cioWidgetId + "-" + elementIndex + "-productName-tagging";
			var partNumberTaggingElement =  cioWidgetId + "-" + elementIndex + "-partNumber-tagging";	
			var productIDTaggingElement =  cioWidgetId + "-" + elementIndex + "-productId-tagging";
			var productBrandTaggingElement =  cioWidgetId + "-" + elementIndex + "-productBrand-tagging";
            var productPriceTaggingElement =  cioWidgetId + "-" + elementIndex + "-productListPrice-tagging";

						if (document.getElementById(productIDTaggingElement)) { document.getElementById(productIDTaggingElement).value = catentryId; }
			if (document.getElementById(productNameTaggingElement)) { document.getElementById(productNameTaggingElement).value = productName; }
			if (document.getElementById(partNumberTaggingElement)) { document.getElementById(partNumberTaggingElement).value = selectedSkuPartNumber; }
			if (document.getElementById(productBrandTaggingElement)) { document.getElementById(productBrandTaggingElement).value = brand; }
            if (document.getElementById(productPriceTaggingElement)) { document.getElementById(productPriceTaggingElement).value = listpriceUSD; }

						if(cioEnableAddToCart == 'yes'){
				if(ciowidgetControlParam == 'RD_DETAILS_PAGE'){
					addToCartVar = elementIdPrefix + elementIndex + "-addToRD";	
				}
				else{
					addToCartVar = elementIdPrefix + elementIndex + "-addToCart";	
				}
				var showAddToCart = true;
				if(definingAttributesCount > 1) {
					showAddToCart = false;
				} else if (personalizedItemFlag != undefined && personalizedItemFlag != null && personalizedItemFlag.toLowerCase() == 'yes'){
					showAddToCart = false;
				} else if (rxFoodIndicator != undefined && rxFoodIndicator != null && rxFoodIndicator.toLowerCase() == 'yes'){
					showAddToCart = false;
				} else if (rxPharmaIndicator != undefined && rxPharmaIndicator != null && rxPharmaIndicator.toLowerCase() == 'rx medication pdp'){
					showAddToCart = false;
				} else if (inStoreOnlyIndicator != undefined && inStoreOnlyIndicator != null && inStoreOnlyIndicator.toLowerCase() == 'yes'){
					showAddToCart = false;
				}				
				var addToCartBtn = cioWidgetId + "-" + elementIndex + "-addToCartBtn";	
				var  isRecentPurchaseContainerVertical = $('#'+cioWidgetId + '-vertical-rfk-rec').parents("#recent-purchase-container").length;
				var  isRecentPurchaseContainerHorizontal = $('#'+cioWidgetId + '-horizontal-rfk-rec').parents("#recent-purchase-container").length;
				var addToCartBtnPrefix = cioWidgetId + "-" + elementIndex;
				if(showAddToCart) {					
					if($('select[id^="'+cioWidgetId+'-'+productPartNumber+'"] option').size() > 1 && !isfromComboBoxFlag){
						$('select[id^="'+cioWidgetId+'-'+productPartNumber+'"]').val("");
						if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
							$(addToCartVar).html('<a disabled="disabled" class="show rfladdTocartLink text-underLine" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</a>');
						} else {
							$(addToCartVar).html('<button disabled="disabled" class="btn btn-primary btn-full show rfladdTocartLink" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</button>');
						}
					} else{
						if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
							$(addToCartVar).html('<a class="show rfladdTocartLink text-underLine" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</a>');
						} else {
							if(ciowidgetControlParam == 'RD_DETAILS_PAGE'){
								var subscriptionId = $('#subscriptionId').val();
								$('#elementPrefix').val(elementIdPrefix);								
								 $(addToCartVar).html('<button class="btn btn-primary btn-full show rfladdTordLink" id="'+ addToCartBtn + '" onclick="MyAccountDisplay.rdAddOnLoginOptions(\''+subscriptionId+'\',\''+ elementIdPrefix+elementIndex + '\');adobeClickTrackLink(this);" adobe_manual_cm_sp="recommeded for you | add to repeat delivery" data-cnstrc-item-id="'+itemId+'"data-cnstrc-variation-id="'+productPartNumber+'" data-cnstrc-strategy-id="'+ciowidgetName+'" data-cnstrc-item-name="'+productName+'" data-cnstrc-category-id="'+category+'">Add to <p class="rd-rfk-button-logo"></p></button>');
							}
							else{
							$(addToCartVar).html('<button class="btn btn-primary btn-full show rfladdTocartLink" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</button>');
							}
						}
					}					
				} else {	
					if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
						$(addToCartVar).html('<a  id="'+ cioWidgetId+'-'+productPartNumber+'-viewdetails' + '" class="rflviewDetailsLink text-underLine" onclick="clickTrackLink(this);" href="'+ pdpURL +'" target="_parent">View Details</a>');		
					} else {
						$(addToCartVar).html('<a  id="'+ cioWidgetId+'-'+productPartNumber+'-viewdetails' + '" class="rflviewDetailsLink" onclick="clickTrackLink(this);" href="'+ pdpURL +'" target="_parent" data-cnstrc-item-id="'+itemId+'"data-cnstrc-variation-id="'+productPartNumber+'" data-cnstrc-strategy-id="'+ciowidgetName+'" data-cnstrc-item-name="'+productName+'" data-cnstrc-category-id="'+category+'"><button class="btn btn-primary btn-full rflViewDetailsLink show">View Details</button></a>');					
					}
				}				
			}

						if(typeof(page) != "undefined" && page != null){
				var pageName = page.page_type.split(" ").join("");
				var elementIdTitle = $("#" + cioWidgetId +"-widgetTitle");
				var elementIdTitleval="";
				var ratingLink_1 = elementIdPrefix + elementIndex + "-rating-link";
				var imageLink_1=  elementIdPrefix + elementIndex + "-img a"; 
				var nameLink_1 = elementIdPrefix + elementIndex + "-name-link"; 
				var addtocartLink_1 = elementIdPrefix + elementIndex + "-addToCart .rfladdTocartLink";
				var viewDetailsLink_1 = elementIdPrefix + elementIndex + "-addToCart .rflviewDetailsLink";

				if(elementIdTitle.length > 0){
					elementIdTitleval=$(elementIdTitle).html();
					elementIdTitleval=elementIdTitleval.split(" ").join("");
					var fullText = pageName+"-_-"+elementIdTitleval+":"+elementIndex+"-_-"+selectedSkuPartNumber;
					$(ratingLink_1).attr("manual_cm_sp",fullText);
					$(imageLink_1).attr("manual_cm_sp",fullText);
					$(nameLink_1).attr("manual_cm_sp",fullText);

										if($(addtocartLink_1).length > 0){
						var fullText_addToCart = fullText + ":addtocart";
						$(addtocartLink_1).attr("manual_cm_sp",fullText_addToCart);
					}

										if($(viewDetailsLink_1).length > 0){
						$(viewDetailsLink_1).attr("manual_cm_sp",fullText);
					}					
				}
			}

						}

				function resetRecommendation(){
		}


						function parseProductDetails(productJson, cioWidgetId, enableSkuSelection){	
			var product =productJson.data; 
			var selectedSwatch = {};			
			var attributes = {};
			var attributeValues = [];
			var definingAttributesCount = 0;
			var products = {};
			var productPartNumber = product.variation_id;
			var productCatentryId = product.catEntryID;
			var productName = productJson.value;
			var brand = product.mfName;
			var imgURL = product.image_url;
			var priceUSD = product.offerprice;
			var listpriceUSD =  product.listprice;
			var rdPriceUSD = product.rdprice;
			var reviewRating = product.AverageRating;
			var reviewCount =  product.TotalReviewCount;
			var isRDEligible = product.PTC_OMNI_REPEAT_DELIVERY_FL;
			var pdpURL = product.url;
			var itemId = product.id;
			var category = "";
			if(product.group_ids != undefined && product.group_ids.length > 0)
				category=product.group_ids[0];

						var personalizedItemFlag = product.PTC_OMNI_PERSONALIZED_ITEM_FL;
			var rxFoodIndicator = typeof(product.PTC_OMNI_RX_FOOD_IND) == 'undefined' ? 'No' : product.PTC_OMNI_RX_FOOD_IND;

						var inStoreOnlyIndicator = typeof(product.PTC_OMNI_IN_STORE_ONLY_FLAG) == 'undefined' ? 'No' : product.PTC_OMNI_IN_STORE_ONLY_FLAG;

						var rxPharmaIndicator = typeof(product.PTC_OMNI_PDP_BEHAVIOR_TEMPLATE) == 'undefined' ? 'undefined' : product.PTC_OMNI_PDP_BEHAVIOR_TEMPLATE;
			var bopusIndicator = typeof(product.PTC_OMNI_BOPUS_FLAG) == 'undefined' ? 'undefined' : product.PTC_OMNI_BOPUS_FLAG;

						if(recommendationParsedSkuDetails[cioWidgetId] == undefined){
				recommendationParsedSkuDetails[cioWidgetId] = {};
				recommendationParsedSkuDetails[cioWidgetId].products = {};
			} else {
				if(recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber] == undefined){
					recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber] = {"attributes": {}};
				}
			}




			recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber] = {"name": productName, "brand": brand, "review_rating": reviewRating ,"review_count": reviewCount, "url":pdpURL , "image_url":imgURL, "price_USD": priceUSD,"listprice_USD": listpriceUSD, "rd_price_USD":rdPriceUSD, "rd_eligible":isRDEligible, "attributes": attributes, "personalizedItemFlag":personalizedItemFlag, "rxFoodIndicator":rxFoodIndicator,"rxPharmaIndicator":rxPharmaIndicator,"inStoreOnlyIndicator":inStoreOnlyIndicator,"catentryId":productCatentryId,"itemId":itemId,"category":category,"bopusIndicator":bopusIndicator};
		}

				function showReviewRating(cioWidgetId, elementIndex, productPartNumber){	

						var elementIdPrefix = "#" + cioWidgetId + "-";
			var rating = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].review_rating;	
			var reviewCount = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].review_count;
			var reviewRatingMainDiv =  elementIdPrefix + elementIndex + "-rating";			
			var reviewRatingLongBarDiv = elementIdPrefix + elementIndex + "-star_limiter  .longbar";

						var reviewRatingLinkElement = elementIdPrefix + elementIndex + "-rating-link";
			var reviewCountElement = elementIdPrefix + elementIndex + "-review-count";
			var reviewRatingLink = recommendationParsedSkuDetails[cioWidgetId].products[productPartNumber].url + '#customerReviews';			
			var num_stars = 5;
			if(rating == undefined || rating == null){
				rating = 0;
			}
			if(reviewCount == undefined || reviewCount == null){
				reviewCount = 0;
			}
			if(!isNaN(rating)) {
				$(reviewRatingMainDiv).attr("title" , rating + "stars");
				var percent = Math.round( rating * 100 / num_stars);
				if(percent > 100) percent = 100;				
				$(reviewRatingLongBarDiv).width(percent + "%");

								if($(reviewRatingLinkElement).length > 0){
					$(reviewRatingLinkElement)[0].href = reviewRatingLink;	
				}
				$(reviewCountElement).html('(' + reviewCount + ')');
			}
		}
		function populateAttribute(rfkWidgetId, productPartNumber, elementIndex,definingAttributesCount){			
			var combobox;
			var option;
			var selectedValue;
			var selectedSwatch = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].selected_swatch;
			var attributes = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].attributes;
			var elementIdPrefix = "#" + rfkWidgetId + "-";
			var skuSelectionVar = elementIdPrefix + elementIndex + "-skuDetailsDiv";
			$(skuSelectionVar).addClass("select-style");
			$(skuSelectionVar).removeClass("select-attribute");			
			var shouldContinueShowing = true;
			if(definingAttributesCount > 0){
				var visibleHidden = false;
				$.each(attributes, function(key,val){	
					if(shouldContinueShowing){
					var comboboxId = rfkWidgetId + "-" + productPartNumber + "-" + key;
					if(typeof(selectedSwatch['defining_attributes']) != 'undefined'){
						selectedValue = selectedSwatch['defining_attributes'][0][key];
					}

										if(definingAttributesCount > 1){
						combobox = $("<select></select>").attr("id", comboboxId).attr("name", comboboxId).attr("class", "form-control disabled").attr("disabled","disabled");

												visibleHidden= true;
					}else{
						combobox = $("<select></select>").attr("id", comboboxId).attr("name", comboboxId).attr("class", "form-control");
					}
					combobox.attr("onchange", "ReflektionHelperJS.changeAttributeSelection('" + rfkWidgetId + "'," + productPartNumber + "," + elementIndex + ",this.value)");
					option =  $('<option />', {text: 'Select '+key, value: ''});
					combobox.append(option);
					$.each(val, function(index,attributeValue) {					
						if(selectedValue == attributeValue){
							option =  $('<option />', {text: attributeValue, value: attributeValue, selected: true});
						} else {
							option =  $('<option />', {text: attributeValue,value: attributeValue});
						}
						combobox.append(option);
					});
					if(definingAttributesCount > 1){
						shouldContinueShowing = false;
					}
				}
				});

								$(skuSelectionVar).append (combobox);
				if(visibleHidden){
					$(skuSelectionVar).css('visibility','hidden');
				}

							}else{
				var comboboxId = rfkWidgetId + "-" + productPartNumber + "-SELECT";
				var skuSelectionVar = elementIdPrefix + elementIndex + "-skuDetailsDiv";
				   $(skuSelectionVar).addClass("select-style");
				   $(skuSelectionVar).removeClass("select-attribute");
				   $(skuSelectionVar).html('<select id="'+comboboxId+'"  class="form-control disabled" disabled><option value=""> Select </option> </select>');
				   $(skuSelectionVar).css('visibility','hidden');
			}
		}

				function isDefiningAttribute(attributeName) {
			var isDefiningAttribute = false;
			$.each(DEFINING_ATTRIBUTE_LIST, function(index,definingAttribute){	
				if(attributeName == definingAttribute){
					isDefiningAttribute = true;
				}
			});			
			return isDefiningAttribute;
		}

				function changeAttributeSelection(rfkWidgetId, productPartNumber, elementIndex, selectedAttribute){
			var attributes = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].attributes;
			var productName = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].name;
			var selectedSwatch = {};
			var selectedAttributeKey = "";
			var selectedAttributeValue = "";
			if(typeof(attributes) != 'undefined') {
				$.each(attributes, function(index,swatch){
					$.each(swatch, function(key,val){
						if(val == selectedAttribute) {
							selectedAttributeKey = index;	
							selectedAttributeValue = val;
			    		}
					});
				});			

								if(selectedAttributeKey != "" && selectedAttributeValue != "") {
					var swatches = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].swatches;
					$.each(swatches, function(index,swatchKey){
						if(typeof(swatchKey['defining_attributes']) != 'undefined'){
				    		$.each(swatchKey['defining_attributes'],function(index,swatchLst){
				    			for(var key in swatchLst){
				    				if(selectedAttributeKey == key && selectedAttributeValue == swatchLst[key]){
				    					selectedSwatch = swatchKey;
				    				}
				    			}
				    		});
						}
					})
					if(Object.keys(selectedSwatch).length > 0) {
						renderProductDetails(rfkWidgetId, elementIndex, selectedSwatch, productPartNumber, true,true);
						$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").removeAttr("disabled","disabled");
					}else{
						$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").attr("disabled","disabled");
					}
				}else{
					$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").attr("disabled","disabled");
				}
			}

						updateSolrPrice();
		}

				function enableRfkRecommendation(){	
			getReflektionEnabled();	
			var enableRecommendation = false;
			if(ENABLE_REFLEKTION){
				var rFKHeader=getCookie("RFKHeader");
				if(typeof(rFKHeader) != "undefined" && rFKHeader != null && rFKHeader == 'rfk' ){
					$("#ENABLE_REFLEKTION").val("true");
					enableRecommendation = true;
				} else{
					setCookie("RFKHeader", 'rfk');
					enableRecommendation = true;
					$("#ENABLE_REFLEKTION").val("true");
				}		
			}else{
				enableRecommendation = false;
				$("#ENABLE_REFLEKTION").val("false");
			}			
			return enableRecommendation;
		}
		function checkBeforeSearchSubmit(){
			var idEle = $("#SimpleSearchForm_SearchTerm");
			if(idEle.length > 0){
				if($(idEle).val().trim() == ""){
					return false;
				}else{
					return true;
				}
			}
		}
		function autoComplete_removeCommaBeforeSubmit(){
			var searchTerm = $("#SimpleSearchForm_SearchTerm");
			var searchButton = $('#submitButton');	
			if(searchTerm.val().length > 0 ){
				searchButton.addClass('active');
				var searchTermVal = searchTerm.val();
				searchTerm.val(searchTermVal.split("’").join("'"));
				if(searchTermVal.indexOf(",")>-1 && searchTermVal.split(",").length > 2 ){
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.split(",").join("");
					searchTermVal = searchTermVal.split("<<COMMA>>").join(",");
					searchTerm.val(searchTermVal);
				}
			}else {
				searchButton.removeClass('active');
			}
		}
		function setCachedSuggestionsURL(url){
			CachedSuggestionsURL = getAbsoluteURL() + url;
		}

				function formSearchPreviewUrl(hrefVal){
			hrefVal = "//"+hrefVal;
			if(typeof(reflektionList) != 'undefined'){
				 var hrefArray = hrefVal.split("/");
				  var href = hrefArray[hrefArray.length -1];
				  var newUrl = reflektionList[href];
				  if(typeof(newUrl) != 'undefined' && newUrl != null && newUrl != ""){
					  return newUrl;
				  }else{
					  return hrefVal;
				  }
			}else{
				 return hrefVal;
			}
		}
		function setSearchSource(searchSource) {
			localStorage.setItem(SEARCH_SOURCE_KEY, searchSource);
		}
		function bopusAreaRestrictionCheck(){
			var  oNearestStores = JSON.parse(localStorage.getItem('petcostores'));
			var curstate = "";
			if(oNearestStores != null && Object.keys(oNearestStores).length != 0){
				 var petcoStoresLocation = {};
				 if(typeof(oNearestStores.petcostores) != "undefined"){
					 petcoStoresLocation =  JSON.parse(oNearestStores.petcostores) != null ? JSON.parse(oNearestStores.petcostores) : {};
					 var oNearestStore = petcoStoresLocation[0];
					 curstate = oNearestStore.STATE;
					 $("#CurrentBOPUSStateGlobal").val(curstate);
						if($("#isBOPUSAreaRestictionEnabeledTMP").length > 0 && $("#isBOPUSAreaRestictionEnabeledTMP").val() == 'true'){
							var states = "";
							if($("#BOPUSAreaRestictionStateTMP").length > 0){
								states = $("#BOPUSAreaRestictionStateTMP").val();
								var stateArray = states.split(",");
								for(var ix = 0 ; ix < stateArray.length ; ix++){
									if(stateArray[ix] == curstate){
										$(".hideBopusAreaRestriction p").html('In-Store Only');
										break;
									}
								}
							}
						}


					 					 				 }

							}
		}

				function cioRecommendation_initBatch(parentWidgetId){
			var recommendationDataForCioCall = prepareDataForRecommendationCall(parentWidgetId);
			callCioRecommendationEngineForWidgetBatch(recommendationDataForCioCall);
		}

				function prepareDataForRecommendationCall(parentWidgetId){

						var recommendationDataForCioCall = {};
			var cioMaxNumberOfProductToDisplay = 0;
			var cioWidgetName = '';

						var cioWidgetName = $("#" + parentWidgetId + "-" + "cioWidgetName").val();
			var cioNumberOfProduct = $("#" + parentWidgetId + "-" + "cioNoOfProducts").val();
			if(parseInt(cioNumberOfProduct) > cioMaxNumberOfProductToDisplay){
				cioMaxNumberOfProductToDisplay = parseInt(cioNumberOfProduct);
			}

						recommendationDataForCioCall.cioWidgetId = parentWidgetId;
			recommendationDataForCioCall.cioWidgetName = cioWidgetName;
			recommendationDataForCioCall.cioNumberOfProductToDisplay = cioMaxNumberOfProductToDisplay;

						return recommendationDataForCioCall;
		}

				function callCioRecommendationEngineForWidgetBatch(recommendationDataForCioCall){

						var accessTokenJSON = $("#CONSTRUCTOR_KEY").val();
			var userType = getCookie("WC_UserType");
			var userId = '';
			if(userType == 'R'){
				userId=getCookie("WC_UserId");
			}
			const constructorio = new ConstructorioClient({
		        apiKey: accessTokenJSON,
		        userId: userId
		    });
			const recommendationRequest = constructorio.recommendations.getRecommendations(
					recommendationDataForCioCall.cioWidgetName,
		        { section: 'Products', numResults: recommendationDataForCioCall.cioNumberOfProductToDisplay }
			);

						recommendationRequest.then(function(data){
				loadCioRecommendationWidgets(data, recommendationDataForCioCall)
		    });
		}


						function loadCioRecommendationWidgets(cioResponseForRecommendationCall, recommendationDataForCioCall){

						var jsonObject={};
			var jsonObjectTitle={};

						var cioRecWidgetId = recommendationDataForCioCall.cioWidgetId;
			var cioRecWidgetName = recommendationDataForCioCall.cioWidgetName;
			var cioRecWidgetTitleName = recommendationDataForCioCall.cioTitleWidgetName;	

			jsonObject =cioResponseForRecommendationCall.response.results;
			jsonObjectTitle = cioResponseForRecommendationCall.response.pod;

						if(typeof(jsonObject) == 'undefined' || jsonObject.length == '0'){
				return true;
			}

						var elementIdPrefix = "#" + cioRecWidgetId + "-";
			var widgetTitleVar = elementIdPrefix + 'widgetTitle';

						var cioEnableSkuSelectionVar = elementIdPrefix + "cioEnableSkuSelection";
			var cioEnableSkuSelection;
			if($(cioEnableSkuSelectionVar).length > 0){
				cioEnableSkuSelection = $(cioEnableSkuSelectionVar).val();
			}


									if(typeof(jsonObjectTitle) != 'undefined' && typeof(jsonObjectTitle.display_name) != 'undefined' ){
				var title = jsonObjectTitle.display_name;
				if(title != ""){
					$(widgetTitleVar).html(title);
				}
			}

						var recommendedSkuCount =  parseInt(jsonObject.length);
			var numberOfProductToDisplay = $(elementIdPrefix + 'cioNoOfProducts').val();
			if(recommendedSkuCount > 0) {
				$(widgetTitleVar).show();			
				var definingAttributesCount = 0;
				for(var productIndex in jsonObject){
					elementIndex = parseInt(productIndex) + 1;			
					if(elementIndex <= numberOfProductToDisplay){
						prodMainDiv = elementIdPrefix + elementIndex;
						$(prodMainDiv).show();	
						parseProductDetails(jsonObject[productIndex], cioRecWidgetId, cioEnableSkuSelection);
						var productPartNumber = jsonObject[productIndex].data.variation_id;
						var selectedSwatch = {};
						renderProductDetails(cioRecWidgetId, elementIndex, selectedSwatch, productPartNumber, false);
					}	
				}

								showOrHideContainer(cioRecWidgetId, true);					

								if(numberOfProductToDisplay > 3) {
					if($(carouselPrev).length > 0) {
						$(carouselPrev).css({'display':'block'})
					}
					if($(carouselNext).length > 0) {
						$(carouselNext).css({'display':'block'})
					}					
				}

							}
		}


				return{
				autoComplete_init: autoComplete_init,
				autoComplete_removeCommaBeforeSubmit: autoComplete_removeCommaBeforeSubmit,
			 	setRfkRecommendationSKU:setRfkRecommendationSKU,
			 	RECOMMENDATION_PDP_SKU:RECOMMENDATION_PDP_SKU,
			 	rfkRecommendation_init: rfkRecommendation_init,
				changeAttributeSelection:changeAttributeSelection,
				checkBeforeSearchSubmit:checkBeforeSearchSubmit,
				setCachedSuggestionsURL:setCachedSuggestionsURL,
				retrievedCachedSuggestions:retrievedCachedSuggestions,
				setSearchSource:setSearchSource,
				bopusAreaRestrictionCheck:bopusAreaRestrictionCheck,
				cioRecommendation_initBatch:cioRecommendation_initBatch,
				widgetsFiredForRecommetnaions:widgetsFiredForRecommetnaions
			 };
	})();

	}